/* eslint-disable no-unneeded-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Loader from './../Loader/Loader';
import AriaModal from './react-aria-modal';
import '../../../assets/ak-cached/2h/stylesheets/modules/reactModal.css';
import closeIcon from '../../../assets/ak-cached/2h/images/close.svg';


function getApplicationNode() {
  return document.getElementById('app');
}

function Modal(props) {
  const {
    children, closeFn, showCloseX, style, className, classNameX, taggingId, isFetching,
  } = props;
  const closeX = (
    <button
      id="modalCloseButton"
      className={(showCloseX ? '' : 'is-visuallyHidden ') + 'floatRight fontSize_5 cursorPointer width24 height24'}
      style={{
        border: 0,
        position: 'absolute',
        background: 'transparent',
        borderSize: 0,
        top: 10,
        right: 10,
        outline: showCloseX || 'none',
		zIndex: 10
      }}
      aria-label="Close modal overlay"
      onClick={showCloseX && closeFn}
      analyticstrack= "modal-overlay-close-cta"
      data-clickstream= {taggingId +"-modal-close-cta"}
      data-track="modal-overlay-close-cta"
    >
      <span className={`${classNameX} icon-close displayInlineBlock floatRight`} style={{ backgroundImage: `url(${closeIcon})` }} />
    </button>
  );

  return (
    <AriaModal
      modelRole = "dialog"
      titleText="Modal"
      getApplicationNode={getApplicationNode}
      onExit={() => { }}
      underlayClickExits
      verticallyCenter
      escapeExits
      isSessionOut={props.isSessionOut}
      {...props}
     
    >
      <div
        className={`ReactModal pad20 modalUnqiueClassName ${className ? className : ''}`}
        style={style}
        id={taggingId}
        
      >
        {isFetching && <Loader />}
        {showCloseX && closeX}
        {children}
      </div>
    </AriaModal>
  );
}

Modal.defaultProps = {
  closeFn: () => { },
  showCloseX: true,
  style: {},
  classNameX: '',
  isFetching: false,
  isSessionOut: false,
};

Modal.propTypes = {
  children: PropTypes.object.isRequired,
  closeFn: PropTypes.func,
  showCloseX: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  classNameX: PropTypes.string,
  taggingId: PropTypes.string,
  isFetching: PropTypes.bool,
  isSessionOut: PropTypes.bool,
};

export default Modal;
